import { Link } from "react-router";
import style from "./Card.module.css";

function Card({ title, description, imageSrc, link }) {
  return (
    <Link to={link}>
      <div className={style.Card}>
        <h2>{title}</h2>
        <img src={imageSrc} alt={title} />
        <p>{description}</p>
      </div>
    </Link>
  );
}

export default Card;
